import { useQuery } from "@tanstack/react-query";
import { Messages } from "@graylog/server-api";
import i18n from "i18n";
import MessageFormatter from "logic/message/MessageFormatter";
import { defaultOnError } from "util/conditional/onError";
export const fetchMessage = async (index, id) => {
  const message = await Messages.search(index, id);
  return MessageFormatter.formatResultMessage(message);
};
const useMessage = (index, id, enabled = true) => {
  const { data, isInitialLoading, error, isError } = useQuery({
    queryKey: ["messages", index, id],
    retry: (count, e) => {
      if (count > 3) {
        return false;
      }
      return e.status !== 404;
    },
    queryFn: () => defaultOnError(
      fetchMessage(index, id),
      i18n.t("views_notifications.load_message_failed", { ns: "search" }),
      i18n.t("views_notifications.could_not_load_message", { ns: "search" })
    ),
    enabled
  });
  return { data, isInitialLoading, error, isError };
};
export default useMessage;
